import { StyleSheet } from 'react-native';

import Layout from '../../config/Layout';
import Colors from '../../config/Colors';

export default StyleSheet.create({
    container: {
        flex: 1,
        paddingTop: Layout.statusBar,
        borderRightWidth: 1,
        borderRightColor: Colors.border
    },
    loading: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1
    },
    itemList: {
        paddingVertical: Layout.gutterMin,
        paddingHorizontal: Layout.gutter,
        flexDirection: 'column',
        borderBottomWidth: 1,
        borderBottomColor: Colors.border
    },
    selectedItem: {
        backgroundColor: Colors.lightBlue
    },
    lineContent: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginVertical: Layout.gutterMin
    },
    itemTitle: {
        fontSize: 18
    },
    itemInfo: {
        flexDirection: 'column',
        justifyContent: 'center'
    },
    itemInfoText: {
        color: Colors.greyDark,
        fontSize: 16
    },
    badgeContainer: {
        width: 80
    },
    badgeText: {
        color: Colors.white,
        fontSize: 16
    },
    iconStatus: {
        marginTop: 3
    },
    emptyState: {
        flex: 1,
        padding: Layout.gutter,
        justifyContent: 'center',
        alignItems: 'center'
    },
    emptyStateText: {
        textAlign: 'center'
    }
});
